import { z } from 'zod';
import { operationIdSchema } from '../operation/operation.schemas.js';
import { isoUtcDateTimeSchema, positiveIntIdSchema } from '../shared/schemas.js';

export const agentIdSchema = positiveIntIdSchema;

export const agentStatusCodeSchema = z.enum(['READY', 'ACTIVE', 'INACTIVE']);
export type AgentStatusCode = z.infer<typeof agentStatusCodeSchema>;

export const agentFirstNameSchema = z
  .string()
  .trim()
  .min(1, 'Le prénom est obligatoire.')
  .max(100, 'Le prénom ne peut pas dépasser 100 caractères.');

export const agentCodeNameSchema = z
  .string()
  .trim()
  .min(1, 'Le nom de code est obligatoire.')
  .max(100, 'Le nom de code ne peut pas dépasser 100 caractères.');

export const joinOperationSchema = z
  .object({
    publicId: z.string().trim().min(1),
    firstName: agentFirstNameSchema,
    codeName: agentCodeNameSchema,
  })
  .strict();

export type JoinOperationInput = z.infer<typeof joinOperationSchema>;

export const agentSchema = z.object({
  id: z.number().int().positive(),
  operationId: operationIdSchema,
  firstName: z.string(),
  codeName: z.string(),
  statusCode: agentStatusCodeSchema,
  joinedAt: isoUtcDateTimeSchema,
  eliminatedAt: isoUtcDateTimeSchema.nullable(),
  abandonedAt: isoUtcDateTimeSchema.nullable(),
  exitedAt: isoUtcDateTimeSchema.nullable(),
  archivedAt: isoUtcDateTimeSchema.nullable(),
  createdAt: isoUtcDateTimeSchema,
  updatedAt: isoUtcDateTimeSchema,
});

export type Agent = z.infer<typeof agentSchema>;

// agentToken est a transmettre dans l'en-tete X-Agent-Token des appels joueur.
// missionId identifie le lobby (/missions/:missionId/briefing).
export const joinOperationResultSchema = z.object({
  agentId: z.number().int().positive(),
  missionId: z.number().int().positive(),
  agentToken: z.string().min(1),
});

export type JoinOperationResult = z.infer<typeof joinOperationResultSchema>;

// Agent tel que les joueurs le voient (TD-029) : prenom (un surnom qui le
// distingue de ses homonymes) et nom de code, jamais d'identifiant interne.
export const publicAgentSchema = z.object({
  firstName: z.string(),
  codeName: z.string(),
});

export type PublicAgent = z.infer<typeof publicAgentSchema>;
